import React, { useEffect, useState } from "react";
import {
    Grid,
    Card,
    CardContent,
    Typography,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Tooltip,
    CircularProgress
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { AttributeCodes, Attributes } from "../../../commons/Attributes";
import { addressEnterpriseCodeAttributes, addressUserCodeAttributes } from "../../../commons/EnumAttributes";
import { DialogAddressActions } from "./DialogAddressActions";
import { CommonStyles } from "../../../commons/CommonStyles";
import { RequiredDataStyles } from "../RequiredDataStyles";
// import HomeIcon from '@material-ui/icons/Home';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import PublicIcon from '@material-ui/icons/Public';
import LocalPostOfficeIcon from '@material-ui/icons/LocalPostOffice';
import { checkIsNullUndefined } from "../../../commons/Utils";
import { CorreosIcon } from "../../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../../commons/EnumsGeneral";

export function AddressCard(props) {
    const { address, isUser, objectAddressActions, hasThreeAddresses } = props;
    const commonClasses = CommonStyles();
    const classes = RequiredDataStyles();
    const { t, i18n } = useTranslation();

    const [codes, setCodes] = useState([]);

    useEffect(() => {
        if (isUser) {
            setCodes(addressUserCodeAttributes);
        } else {
            setCodes(addressEnterpriseCodeAttributes);
        };
    }, [isUser]);

    const mountAddress = () => {
        let via = address[Attributes[AttributeCodes.Via].attributeValue];
        let addr = address[Attributes[AttributeCodes.Address].attributeValue];
        let addr1 = address[Attributes[AttributeCodes.Address1].attributeValue];
        addr1 = checkIsNullUndefined(addr1) ? "" : addr1;
        let text = via + " " + addr + " " + addr1;
        return mountTextLine("HomeIcon", text);
    };

    const mountCity = () => {
        let city = address[Attributes[AttributeCodes.City].attributeValue];
        let region = address[Attributes[AttributeCodes.Province].attributeValue];
        let text = (checkIsNullUndefined(city) || checkIsNullUndefined(region)) ? "-" : city + ", " + region;
        return mountTextLine("LocationCityIcon", text);
    };

    const mountCountry = () => {
        let country = address[Attributes[AttributeCodes.Country].attributeValue];
        return mountTextLine("PublicIcon", country);
    };

    const mountPostalCode = () => {
        let auxPostalCodeCode = isUser ? AttributeCodes.PostalCode : AttributeCodes.EntPostalCode;
        let postalCode = address[Attributes[auxPostalCodeCode].attributeValue];
        let text = (checkIsNullUndefined(postalCode)) ? "-" : postalCode;
        return mountTextLine("LocalPostOfficeIcon", text);
    };

    const mountTextLine = (icon, text) => {
        let auxIcon;
        switch (icon) {
            case "HomeIcon":
                auxIcon = <CorreosIcon iconSelected={iconNames.address} iconName="Address Icon" iconState="basic" iconScale={2.5} />;
                // <HomeIcon
                //     className={classes.iconsStyles}
                //     style={{ float: "left" }}
                // />;
                break;
            case "LocationCityIcon":
                auxIcon = <CorreosIcon iconSelected={iconNames.city} iconName="City Icon" iconState="basic" iconScale={2.5} />;
                // auxIcon = <LocationCityIcon
                //     className={classes.iconsStyles}
                //     style={{ float: "left" }}
                // />;
                break;
            case "PublicIcon":
                auxIcon = <CorreosIcon iconSelected={iconNames.world} iconName="Country Icon" iconState="basic" iconScale={2.5} />;
                // auxIcon = <PublicIcon
                //     className={classes.iconsStyles}
                //     style={{ float: "left" }}
                // />;
                break;
            case "LocalPostOfficeIcon":
                auxIcon = <CorreosIcon iconSelected={iconNames.mail} iconName="Mail Icon" iconState="basic" iconScale={2.5} />;
                // auxIcon = <LocalPostOfficeIcon
                //     className={classes.iconsStyles}
                //     style={{ float: "left" }}
                // />;
                break;
            default:
                break;
        };

        return (
            <Grid item container xs={12} className={classes.cardIcons}>
                {auxIcon}
                <Tooltip title={text}>
                    <Typography component="h1" variant="h6" noWrap align="left" style={{ padding: "0.5em 0 0.5em 0.5em" }}>
                        {text}
                    </Typography>
                </Tooltip>
            </Grid>);
    };

    return (
        <Grid item xs={12} md={6}>
            <Card style={{ backgroundColor: "#fafafa" }}>
                <Grid
                    container
                    item
                    xs={12}
                >
                    {objectAddressActions.activeAddress == address.id && objectAddressActions.actionCircularProgress ?
                        <Grid item xs={12} className={commonClasses.gridIdentityCenter}>
                            <CircularProgress style={{ margin: "auto", marginTop: "1em", marginBottom: "1em" }}></CircularProgress>
                        </Grid> : (
                            <CardContent style={{ paddingTop: "1em", paddingRight: "0.5em", paddingBottom: "0.5em", paddingLeft: "1em", maxWidth: "100%" }}>
                                <Grid container item md={12} xs={12}>
                                    <Grid item xs={9}>
                                        <Typography component="h1" variant="h4" noWrap align="left" style={{ marginLeft: "0.25em" }}>
                                            {address[Attributes["ALI"].attributeValue]}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <DialogAddressActions
                                            objectAddressActions={objectAddressActions}
                                            isCard={true}
                                            address={address}
                                            circularProgress={objectAddressActions.addressCircularProgress}
                                            hasThreeAddresses={hasThreeAddresses}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} >
                                        {mountAddress()}
                                        {mountCity()}
                                        {mountCountry()}
                                        {mountPostalCode()}
                                    </Grid>
                                    <Grid
                                        container
                                        item
                                        xs={12}
                                        style={{ marginTop: "0.5em" }}
                                    >
                                        <Grid item xs={12}>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={address?.favourite}
                                                            name="check"
                                                            disabled={true}
                                                            className={commonClasses.leftButton}
                                                        />
                                                    }
                                                    label={t("userDataFavouriteDirection")}
                                                />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        )
                    }
                </Grid>
            </Card>
        </Grid>
    );
}
